import { render, staticRenderFns } from "./HistoryPacient.vue?vue&type=template&id=618c6d8b&"
import script from "./HistoryPacient.vue?vue&type=script&lang=js&"
export * from "./HistoryPacient.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPacient.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports